import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function classnames(...args: ClassValue[]) {
  return twMerge(clsx(args));
}

export const cn = classnames;
